import React from 'react';
import './Form8821.css';
import DataGrid from '../../Components/DataGrid/DataGrid';
import { Form8821Props, Form8821State, IFormTransactionDetails } from './interface';
import CustomMaterialMenu from '../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';



import { TableColumn } from 'react-data-table-component';
import Swal from "sweetalert2";
import ProfileServices from '../../Services/ProfileServices';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import FormServices from '../../Services/FormServices';
import ViewUser from '../UserManagement/ViewUser/ViewUser';
import { createRoot } from 'react-dom/client';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import VisibilityIcon from '@mui/icons-material/Visibility';





class Form8821 extends React.Component<Form8821Props, Form8821State> {

    constructor(props_: any) {
        super(props_);

        this.state = {
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            transactionData: [],
            currentSortColumn: 'actionRequired',
            sortingDirection: 'desc'

        }
    }

    ///... columns to be displayed in grid
    private formColumns: TableColumn<IFormTransactionDetails>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IFormTransactionDetails) => row.taxPayerName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: IFormTransactionDetails) => row.email,
            sortable: true,
        },
        {
            name: 'Phone Number',
            selector: (row: IFormTransactionDetails) => row.phoneNumber,
            sortable: true,
        },
        {
            name: 'Transcript Details',
            cell: (row: IFormTransactionDetails) => <div className={`fom8821-button-container`}>
            <div className={`fom8821-button-icon viewIcon ${row.form8821.isApproved ? '': 'disabled'}` } onClick={() => { this.pullTranscriptDetails(row) }}>
                <VisibilityIcon />
            </div>
            <div className={`fom8821-button-text viewText ${row.form8821.isApproved ? '': 'disabled'}`} onClick={() => { this.pullTranscriptDetails(row) }}>
                <span> View Details </span>
            </div>
        </div>,
            sortable: false,
        },
        {
            name: 'Action',
            cell: (row: IFormTransactionDetails) => 
                    <div className='resub-container'
                        onClick={() => { this.openEachFromDetails(row); }}>
                        <div className={`Form8821-resub-icon ${row.actionRequired ? '': 'disabled'}`}>
                            <WarningAmberIcon />
                        </div>
                        <div className={`Form8821-resub-text ${row.actionRequired ? '': 'disabled'}`}>
                            <span> Action Needed </span>
                        </div>
                    </div>,
            sortable: true
        },
        {
            cell: row => <CustomMaterialMenu
                fontSize="small"
                multiPopoverItems={[
                    {
                        key: "form8821",
                        label: "Submitted Form-8821 to IRS",
                        
                        disabled: ((row.form8821.isSignatureCompleted && (row.form8821.isApproved || row.form8821.isSubmittedToIRS || row.form8821.isRejected)) && !(row.form8821.isEligibleToResubmit && row.form8821.isSubmittedToIRS && row.form8821.isSignatureCompleted)) || !row.form8821.isSignatureCompleted,

                        textStyle: ((row.form8821.isSignatureCompleted && (row.form8821.isApproved || row.form8821.isSubmittedToIRS || row.form8821.isRejected)) && !(row.form8821.isEligibleToResubmit && row.form8821.isSubmittedToIRS && row.form8821.isSignatureCompleted)) || !row.form8821.isSignatureCompleted? 'cv-disabled' : ''
                        
                    },
                    {
                        key: "jointForm8821",
                        label: "Submitted spouse's Form-8821 to IRS",
                        
                        disabled: row.form8821.nonTaxpayer ? (( row.form8821.nonTaxpayer.isSignatureCompleted && (row.form8821.nonTaxpayer.isApproved || row.form8821.nonTaxpayer.isSubmittedToIRS || row.form8821.nonTaxpayer.isRejected)) && !(row.form8821.nonTaxpayer.isEligibleToResubmit && row.form8821.nonTaxpayer.isSubmittedToIRS && row.form8821.isSignatureCompleted)) || !row.form8821.nonTaxpayer.isSignatureCompleted : true,

                        textStyle: row.form8821.nonTaxpayer ? (( row.form8821.nonTaxpayer.isSignatureCompleted && (row.form8821.nonTaxpayer.isApproved || row.form8821.nonTaxpayer.isSubmittedToIRS || row.form8821.nonTaxpayer.isRejected)) && !(row.form8821.nonTaxpayer.isEligibleToResubmit && row.form8821.nonTaxpayer.isSubmittedToIRS && row.form8821.nonTaxpayer.isSignatureCompleted)) || !row.form8821.nonTaxpayer.isSignatureCompleted? 'cv-disabled' : '' : 'cv-disabled'
                        
                    },
                    {
                        key: "form433A",
                        label: "Submitted Form-433A to IRS",
                        disabled: ((row.form433A.isSignatureCompleted && (row.form433A.isApproved || row.form433A.isSubmittedToIRS || row.form433A.isRejected)) && !(row.form433A.isEligibleToResubmit && row.form433A.isSubmittedToIRS && row.form433A.isSignatureCompleted)) || !row.form433A.isSignatureCompleted,

                        textStyle: ((row.form433A.isSignatureCompleted && (row.form433A.isApproved || row.form433A.isSubmittedToIRS || row.form433A.isRejected)) && !(row.form433A.isEligibleToResubmit && row.form433A.isSubmittedToIRS && row.form433A.isSignatureCompleted)) || !row.form433A.isSignatureCompleted ? 'cv-disabled' : ''
                    },
                    {
                        key: "jointForm433A",
                        label: "Submitted spouse's Form-433A to IRS",
                        
                        disabled: row.form433A.nonTaxpayer ? (( row.form433A.nonTaxpayer.isSignatureCompleted && (row.form433A.nonTaxpayer.isApproved || row.form433A.nonTaxpayer.isSubmittedToIRS || row.form433A.nonTaxpayer.isRejected)) && !(row.form433A.nonTaxpayer.isEligibleToResubmit && row.form433A.nonTaxpayer.isSubmittedToIRS && row.form433A.isSignatureCompleted)) || !row.form433A.nonTaxpayer.isSignatureCompleted : true,

                        textStyle: row.form433A.nonTaxpayer ? (( row.form433A.nonTaxpayer.isSignatureCompleted && (row.form433A.nonTaxpayer.isApproved || row.form433A.nonTaxpayer.isSubmittedToIRS || row.form433A.nonTaxpayer.isRejected)) && !(row.form433A.nonTaxpayer.isEligibleToResubmit && row.form433A.nonTaxpayer.isSubmittedToIRS && row.form433A.nonTaxpayer.isSignatureCompleted)) || !row.form433A.nonTaxpayer.isSignatureCompleted? 'cv-disabled' : '' : 'cv-disabled'
                        
                    },
                    {
                        key: "form433D",
                        label: "Submitted Form-433D to IRS",
                        disabled: ((row.form433D.isSignatureCompleted && (row.form433D.isApproved || row.form433D.isSubmittedToIRS || row.form433D.isRejected)) && !(row.form433D.isEligibleToResubmit && row.form433D.isSubmittedToIRS && row.form433D.isSignatureCompleted)) || !row.form433D.isSignatureCompleted,

                        textStyle: ((row.form433D.isSignatureCompleted && (row.form433D.isApproved || row.form433D.isSubmittedToIRS || row.form433D.isRejected)) && !(row.form433D.isEligibleToResubmit && row.form433D.isSubmittedToIRS && row.form433D.isSignatureCompleted)) || !row.form433D.isSignatureCompleted ? 'cv-disabled' : ''
                    }
                ]}
                onPopoverClick={(key_: string, label_: string) => {
                    if (key_ === 'form8821' && !(row.form8821.isApproved || row.form8821.isSubmittedToIRS || row.form8821.isRejected)) {
                        this.updateFormSubmission(row.userId, key_);
                    }
                    else if (key_ === 'jointForm8821' && !(row.form8821.nonTaxpayer.isApproved || row.form8821.nonTaxpayer.isSubmittedToIRS || row.form8821.nonTaxpayer.isRejected)) {
                        this.updateFormSubmission(row.form8821.nonTaxpayer.userId, 'form8821');
                    }
                    else if (key_ === 'form433A' && !(row.form433A.isApproved || row.form433A.isSubmittedToIRS || row.form433A.isRejected)) {
                        this.updateFormSubmission(row.userId, key_);
                    }
                     else if (key_ === 'jointForm433A' && !(row.form433A.nonTaxpayer.isApproved || row.form433A.nonTaxpayer.isSubmittedToIRS || row.form433A
                        .nonTaxpayer.isRejected)) {
                        this.updateFormSubmission(row.form433A.nonTaxpayer.userId, 'form433A');
                    }
                    else if (key_ === 'form433D' && !(row.form433D.isApproved || row.form433D.isSubmittedToIRS || row.form433D.isRejected)) {
                        this.updateFormSubmission(row.userId, key_);
                    }
                }}
            />,
            allowOverflow: true,
            button: true,
            width: '56px'
        }
    ];

    /**
     * After will get triggered after mounting the component
     */
    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getUserDetails(accesstoken.toString());
            })
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    /**
     * Below function retrieves all form 8821 details submitted by tax payer
     */
    private async getAllForm8821Details() {
        let pageIndex: number = (this.state.currentPage - 1);
        let sortingObj: any = {};
        ///... check and set based on current sorting column in state
        if (this.state.currentSortColumn != '') {
            sortingObj['column'] = this.state.currentSortColumn;
            sortingObj['direction'] = this.state.sortingDirection;
        }

        ///... payload for form 8821 request
        let pagination: any = {
            "offset": (pageIndex * this.state.currentRowsPerPage),
            "limit": this.state.currentRowsPerPage,
            "sort": { ...sortingObj }
        };

        FormServices.getAllForms({...pagination, searchFilter: this.state.searchText}, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then((resp: any) => {
                    this.setState({ transactionData: resp.result, totalRows: resp.totalCount });
                });
            }
        });
    }

    /**
     * 
     * @param userId - unique id of the user
     * @param key - kef should be the form name that needs to get updated
     */
    private updateFormSubmission(userId: string, key: string) {

        try {
            FormServices.updateFormSubmission({ userId: userId, formName: key }, this.state.accessToken).then(r => {

                if (r.ok) {
                    this.getAllForm8821Details();
                    let succKey = key == 'form8821' ? 'Form 8821' : key == 'form433A' ? 'Form 433-A' : 'Form 433-D';
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: `Updated IRS Submission for ${succKey} successfully`,
                    
                    });
                }

            });
        }
        catch (ex) {
            ///... give swal error
        }

    }

    /**
     * Action will get user details based on the token
     * @param accessToken - accesstoken stored after login
     */
    private getUserDetails(accessToken: string) {
        ProfileServices.getUserDetails(accessToken).then(r => {
            if (r.ok) {
                this.getAllForm8821Details();
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Failed to load content!",
                });
            }
        });
    }

    /**
     * Below function request the IRS transcript data as html and bind the same to swal
     * @param row {IForm8821Details} - respective row details for which the download button is clicked
     */
    private async pullTranscriptDetails(row: IFormTransactionDetails) {
        try {

            FormServices.viewTranscript({ userId: row.userId }, this.state.accessToken).then((r: any) => {
                if (r.ok) {
                    r.json().then((resp: any) => {
                        console.log(resp)
                        Swal.fire({
                            title: "IRS TRNASCRIPT",
                            html: resp['data'], // Set the HTML content
                            showCloseButton: true, // Enable the close button
                            focusConfirm: false,
                            confirmButtonText: "Close",
                            customClass: {
                                popup: "custom-swal-popup", // Add custom class to the popup
                            }
                        });
                    });



                }
            }).catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Failed to load content!",
                });
            });
        }
        catch (ex) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Failed to load content!",
            });
        }
    }

    /**
     * Below function will provide the actual field which get sorted based on the provided table title
     * @param columnName  - name of the column which is getting sorted
     * @returns - returns the field name which is about to get sorted
     */
    identifySortingMapColumn(columnName: string): string {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'taxPayerName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Phone Number":
                actualColName = 'phoneNumber';
                break;
            case "Action":
                actualColName = 'actionRequired';
                break;

        }
        return actualColName;
    }

    public render() {
        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='Form Details'
                    search=' Form Details'
                    onChangePage={(page: number, totalRows: number) => {
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getAllForm8821Details();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                         this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getAllForm8821Details();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1

                        }, () => {
                            this.getAllForm8821Details();
                        })
                    }}
                    columns={this.formColumns}
                    data={this.state.transactionData}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                    onRowClicked={
                        (row) => {
                            this.openEachFromDetails(row);
                        }
                    }
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getAllForm8821Details();
                        })
                    }}
                />
            </div>
        )
    }

    private openEachFromDetails(row: IFormTransactionDetails) {
        try {
            const reactContainer = document.createElement('div');

            Swal.fire({
                title: 'Form Details',
                html: reactContainer,
                showConfirmButton: true,
                customClass: {
                    popup: "custom-swal-popup", // Add custom class to the popup
                },
                didOpen: () => {
                    // Render the React component into the container
                    const root = createRoot(reactContainer);
                    root.render(<ViewUser userId={row.userId} rowDetail={{ ...row }} form8821={row.form8821} form433A={row.form433A} form433D={row.form433D} />);
                },
                willClose: () => {
                    // Clean up the React component when Swal is closed
                    if (reactContainer) {
                        //reactContainer.unmount();
                    }
                },
            });
        }
        catch {

        }
    }

}



export default Form8821;